"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBidderList = void 0;
var getIxPrebidSizes_1 = require("./getIxPrebidSizes");
var placementUtils_1 = require("./../../../helpers/placementUtils");
/**
 * returns a list of bidders
 */
function getBidderList(placement, testGroups) {
    var ixBidders = (0, getIxPrebidSizes_1.getIxPrebidSizes)(placement);
    var bidderDetails = (0, placementUtils_1.getBidderDetails)(placement);
    var bidders = [
        {
            gdprEnabled: true,
            exclude: {},
            config: {
                bidder: "rubicon",
                params: {
                    accountId: 7941,
                    siteId: 346974,
                    zoneId: bidderDetails.rubiconZone,
                    // optional parameters we should probably do something with
                    // see: http://docs.prebid.org/dev-docs/bidders/rubicon.html
                    //keywords: "string",
                    //inventory: "json object",
                    //visitor: "json object",
                    //position: "atf/btf",
                    //userId: "wattpad.utils.external_id (wp_id)",
                    //floor
                    //latLong
                    //video
                },
            },
        },
        {
            gdprEnabled: true,
            exclude: {
                desktop: ["AE"],
                mobile: ["SA"],
            },
            config: {
                bidder: "pubmatic",
                params: {
                    publisherId: "159971",
                    adSlot: bidderDetails.pubmaticSlot
                        ? bidderDetails.pubmaticSlot.toString()
                        : null,
                    // additional optional parameters
                    // see: http://docs.prebid.org/dev-docs/bidders/pubmatic.html
                    // pmzoneid
                    // lat
                    // lon
                    // yob (year of birth)
                    // gender
                    // kadpageurl
                    // kadfloor
                    // currency
                    // dctr
                    // bcat (blocked IAB categories)
                    // deals
                    // outstreamAU (for outstream)
                },
            },
        },
        {
            gdprEnabled: true,
            exclude: {
                desktop: ["BR", "IN", "TR"],
            },
            config: {
                bidder: "criteo",
                params: {
                    networkId: 10933,
                    // see:  https://docs.prebid.org/dev-docs/bidders#criteo
                    // zoneId (deprecated)
                    // nativeCallback
                    // integrationMode
                },
            },
        },
        {
            gdprEnabled: true,
            exclude: {},
            config: {
                bidder: "triplelift",
                params: {
                    inventoryCode: bidderDetails.tripleliftInvCode,
                    // additional optional parameters
                    // see: https://docs.prebid.org/dev-docs/bidders/triplelift.html
                    // floor
                    //
                },
            },
        },
        {
            gdprEnabled: false,
            exclude: {
                desktop: ["IN"],
                mobile: [],
            },
            config: {
                bidder: "sovrn",
                params: {
                    tagid: bidderDetails.sovrnTag
                        ? bidderDetails.sovrnTag.toString()
                        : null,
                    // additional optional parameters
                    // see: https://docs.prebid.org/dev-docs/bidders/sovrn.html
                    // bidfloor
                },
            },
        },
        {
            gdprEnabled: true,
            exclude: {},
            config: {
                bidder: "sharethrough",
                params: {
                    pkey: bidderDetails.sharethroughPKey,
                    // optional parameters
                    // see: https://docs.prebid.org/dev-docs/bidders/sharethrough
                    // bidfloor
                    // iframe: Render ad in iframe
                    // iframeSize: size of the iframe
                    // bcat:  blocked IAB categories
                    // badv: array of blocked advertisers by domain.  Might be useful
                },
            },
        },
        {
            gdprEnabled: false,
            exclude: {},
            onlyInCountry: ["AU", "CA", "NZ", "US"],
            config: {
                bidder: "33across",
                params: {
                    siteId: bidderDetails["33acrossSiteId"],
                    productId: "siab",
                    // optional parameters
                    // see: https://docs.prebid.org/dev-docs/bidders/33across
                },
            },
        },
    ];
    ixBidders.forEach(function (bidder) {
        bidders.push({
            gdprEnabled: false,
            exclude: {},
            config: bidder,
        });
    });
    // shemedia is odd. We use the same zoneId for all placements. Because of that
    // we don't have to add it to the big map of placment names to id's, and it only
    // exists in this file.
    //
    if (testGroups.ENABLE_SHEMEDIA) {
        bidders.push({
            gdprEnabled: true,
            exclude: {},
            onlyInCountry: ["CA", "US"],
            config: {
                bidder: "shemedia",
                params: {
                    accountId: 10278,
                    siteId: 210096,
                    zoneId: 3618968,
                    // optional parameters we should probably do something with
                    // see: http://docs.prebid.org/dev-docs/bidders/rubicon.html
                    //keywords: "string",
                    //inventory: "json object",
                    //visitor: "json object",
                    //position: "atf/btf",
                    //userId: "wattpad.utils.external_id (wp_id)",
                    //floor
                    //latLong
                    //video
                },
            },
        });
    }
    return bidders;
}
exports.getBidderList = getBidderList;
